import { SERVER_API_URL } from './server-api';
import type { Locale } from './locale';

/**
 * Fri frakt-tröskeln, hämtad från store_settings.shipping_tiers.
 *
 * Tröskeln stod tidigare inskriven som text i sv.json ("5 000 kr") och i
 * en.json ("€430" — kvar från Montenegro-tiden, då engelska betydde export i
 * EUR). Två hårdkodade belopp från olika epoker som ingen jämförde: de råkade
 * stämma mot varandra på kursen 2026-09, men hade drivit isär vid nästa
 * kursrörelse eller nästa ändring av fraktvillkoren, och ingen hade märkt det.
 *
 * Nu finns EN källa — samma tabell som driver kassan och routes/feed.ts.
 */

/** Reservvärde om API:t inte svarar. Speglar shipping_tiers 2026-09-02. */
const FALLBACK_THRESHOLD = 5000;

interface Tier { min: number; max: number | null; price: number }

export function thresholdFromTiers(tiers: Tier[] | undefined): number {
  const free = tiers?.find((t) => t.price === 0);
  return free?.min ?? FALLBACK_THRESHOLD;
}

/** "5 000 kr" — priserna är i SEK på båda språken sedan 2026-09-02. */
export function formatThreshold(amount: number, locale: Locale): string {
  return new Intl.NumberFormat(locale === 'en' ? 'en-GB' : 'sv-SE', {
    style: 'currency',
    currency: 'SEK',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

/** Serversidan: hämtar tröskeln med 5 minuters ISR-cache. */
export async function getFreeShippingThreshold(): Promise<number> {
  try {
    const res = await fetch(`${SERVER_API_URL}/checkout/shipping`, { next: { revalidate: 300 } });
    if (!res.ok) return FALLBACK_THRESHOLD;
    const data = await res.json();
    return thresholdFromTiers(data?.tiers);
  } catch {
    return FALLBACK_THRESHOLD;
  }
}
